import React from "react";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import ScoresContainer from "./scoresContainer";

function ScoreHistroy() {
  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <ScoresContainer />
      </div>
    </AnimatedPageContainer>
  );
}

export default ScoreHistroy;
